import { createSlice } from '@reduxjs/toolkit';
import { addSelectedCallerId, removeAllCallerId, removeCallerId, setCallerIds } from './utils';
import { CallerIdState } from './types';

const initialState: CallerIdState = {
  callerIds: [],
  lastSelectedCallerId: undefined,
};

const callerIdSlice = createSlice({
  name: 'callerIdSlice',
  initialState,
  reducers: {
    setCallerIds,
    removeCallerId,
    addSelectedCallerId,
    removeAllCallerId,
  },
});

export default callerIdSlice;
